import { MutableRefObject, RefObject, useRef } from 'react';
import DescriptionWithImageAccordion from '@features/pages/components/PagesAccordion/components/DescriptionWithImageAccordion';
import theme from '@styles/theme';
import Heading from '@components/Heading/Heading';
import Button from '@components/Button/Button';
import Icon from '@components/icons/Icon';
import styles from '@features/pages/components/PagesAccordion/PagesAccordion.styles';
import contentStyles from '@features/pages/PagesContent.styles';
import FrameAccordion from '@features/pages/components/PagesAccordion/components/FrameAccordion';
import ImageAccordion from '@features/pages/components/PagesAccordion/components/ImageAccordion';
import { TCmsBlocks } from '@features/cms/typescript';
import { ICategoryDescriptionWithImage, IFrameAccordion, IItemAccordion, IImageAccordion } from '@features/pages/typescript';
import { useResponsive } from '@features/responsive';
import { removeTelephoneFromAnchor } from '@utils/sanitizeHtml';
type PropsType = {
  id: string;
  header: string;
  accordionItem: IItemAccordion;
  onClick: (childrenRef: RefObject<HTMLDivElement | null>) => void;
  defaultBackground: string;
  isOpen: boolean;
  isFirst: boolean;
  childrenRef: MutableRefObject<HTMLDivElement | null> | null;
};
const PagesAccordionItem = ({
  id,
  header,
  accordionItem,
  isOpen,
  onClick,
  isFirst,
  defaultBackground,
  childrenRef
}: PropsType) => {
  const {
    isWiderThanDesktop
  } = useResponsive();
  const childRef = useRef<HTMLDivElement | null>(null);
  const handleClick = () => {
    onClick(childRef);
  };
  return <div sx={styles.accordionItem} id={id}>
      <div sx={styles.accordionHeader} onClick={handleClick} onKeyDown={handleClick} aria-hidden="true">
        <Heading h={isFirst ? 1 : 4} headingType={4} mobile color={theme.rawColors.darkGrey700}>
          {header}
        </Heading>
        <Button variant="iconOnly" addSx={styles.addButton} cy="CloseButton">
          <Icon icon={isOpen ? 'Minus2' : 'Add'} size={['24px', '24px', '32px', '40px']} />
        </Button>
      </div>

      <div sx={styles.accordionBlockContent(isOpen)} ref={ref => {
      childRef.current = ref;
      if (childrenRef && ref) {
        childrenRef.current = ref;
      }
    }}>
        {Object.values(accordionItem).map((item: TCmsBlocks) => {
        const {
          type,
          code
        } = item;
        const description = 'description' in item ? item.description as string || '' : '';
        const dataDescription = isWiderThanDesktop ? removeTelephoneFromAnchor(description) : description;
        switch (type) {
          case 'frame':
            return <FrameAccordion key={`fa-${code}`} frame={item as IFrameAccordion} defaultBackground={defaultBackground} />;
          case 'image':
            return 'images' in item && <ImageAccordion key={`img-${code}`} imageAccordion={item as IImageAccordion} />;
          case 'wysiwyg':
            return <div sx={contentStyles.containerContent(true)} key={`wys-${code}`} dangerouslySetInnerHTML={{
              __html: dataDescription
            }} />;
          case 'descriptionWidthImage':
            return <DescriptionWithImageAccordion key={`de-${code}`} descriptionWithImageAccordion={item as ICategoryDescriptionWithImage} />;
          default:
            break;
        }
        return <></>;
      })}
      </div>
    </div>;
};
export default PagesAccordionItem;